// src/analytics.js
//
// Camada de medicao do UMARKT (Google Analytics 4).
//
// POR QUE NAO E O SNIPPET PADRAO DO GOOGLE:
// o site e uma SPA com react-router. O gtag padrao dispara UM pageview no
// carregamento e nunca mais. Navegar de / para /imoveis nao registra nada.
// Instalado do jeito comum, o GA4 reportaria que todo visitante so ve a
// home — e decisao de produto seria tomada em cima de um numero falso.
//
// Aqui: config com send_page_view: false, e o pageview e disparado a cada
// troca de rota pelo componente RastreioDeRota.
//
// LIGA/DESLIGA: tudo depende de REACT_APP_GA_ID existir no ambiente de
// build. Sem a variavel, nenhuma requisicao sai e nenhum script carrega —
// o codigo fica inerte de proposito, para poder ser versionado antes da
// conta existir.

const ID = (process.env.REACT_APP_GA_ID || '').trim()

export const analyticsAtivo = () => Boolean(ID)

let iniciado = false

export function iniciarAnalytics() {
  if (!ID || iniciado || typeof window === 'undefined') return
  iniciado = true

  window.dataLayer = window.dataLayer || []
  function gtag() { window.dataLayer.push(arguments) }
  window.gtag = gtag

  // Consent Mode v2 — postura "so analitico".
  // Nada de publicidade sem consentimento explicito. Um banner de cookies
  // que libere ad_storage e um ciclo proprio, ainda nao feito.
  gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'granted'
  })

  const s = document.createElement('script')
  s.async = true
  s.src = `https://www.googletagmanager.com/gtag/js?id=${ID}`
  document.head.appendChild(s)

  gtag('js', new Date())
  gtag('config', ID, { send_page_view: false })
}

export function paginaVista(caminho, titulo) {
  if (!ID || !window.gtag) return
  window.gtag('event', 'page_view', {
    page_path: caminho,
    page_location: window.location.href,
    page_title: titulo || document.title
  })
}

// Eventos de negocio. Chamar de dentro dos componentes, por exemplo:
//   evento('busca_realizada', { termo: texto })
//   evento('contato_whatsapp', { imovel_id: id })
export function evento(nome, parametros) {
  if (!ID || !window.gtag) return
  window.gtag('event', nome, parametros || {})
}
